function setCssVar(element, property, value) {
  const elem = element ? element : document.documentElement;
  elem.style.setProperty(property, value);
}

export default setCssVar;